import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import {
  Grid,
  Button
} from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Topbar from "../global/Topbar";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';



function DesignationMaster(props) {
  const [designations, setDesignations] = useState([]);
  const [desigCode, setDesigCode] = useState('');
  const [designation, setDesignation] = useState('');
  const [designationEng, setDesignationEng] = useState('');
  
  const [errorMessage, setErrorMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [formMode, setFormMode] = useState('add');
  const [editDesigCode, setEditDesigCode] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [designationMasterEntries, setDesignationMasterEntries] = useState([]);

  const [deleteEntryNo, setDeleteEntryNo] = useState(null);
  const [openConfirmation, setOpenConfirmation] = useState(false);  

  useEffect(() => {
    fetchDesignationMaster();
  }, []);

  const fetchDesignationMaster = async () => {
    try {
      const response = await axios.get('https://www.wingap.net.in/api/designations');
      setDesignationMasterEntries(response.data);
      const maxEntryNo = calculateMaxEntryNo(response.data);
      const nextEntryNo = maxEntryNo + 1;
      setDesigCode(nextEntryNo)
      //console.log(response);
    } catch (error) {
      console.log('error:', error);
    }
  };


  const calculateMaxEntryNo = (entries) => {
    let maxEntryNo = 0;
    for (const entry of entries) {
      if (entry.DesigCode > maxEntryNo) {
        maxEntryNo = entry.DesigCode;
      }
    }
    return maxEntryNo;
  };

  const addDesignation = async () => {
    try {
      await axios.post('https://www.wingap.net.in/api/designations', {
        DesigCode: desigCode,
        Designation: designation,
        DesignationEng: designationEng,
        USERID: props.name
      });
      fetchDesignationMaster();
      setDesigCode('');
      setDesignation('');
      setDesignationEng('');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const updateDesignation = async (desigCode) => {
    try {
      await axios.put(`https://www.wingap.net.in/api/designations/${desigCode}`, {
        DesigCode: desigCode,
        Designation: designation,
        DesignationEng: designationEng,
        USERID: props.name
      });
      fetchDesignationMaster();
      setDesigCode('');
      setDesignation('');
      setDesignationEng('');
      setFormMode('add');
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleDeleteConfirmation = async () => {
    try {
      if (deleteEntryNo) {
        await deleteDesignation(deleteEntryNo.DesignCode);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const deleteDesignation = async (DesigCode) => {
    try {
      const response = await axios.delete(`https://www.wingap.net.in/api/designations/${DesigCode}`, {
        headers: {
          'username': props.name,
        },
      });

      if (response.status === 200) {
        fetchDesignationMaster();
      }
    } catch (error) {
      console.log('Error:', error);

      if (error.response && error.response.status === 403) {
        // User does not have permission to delete account group
        setErrorMessage('Permission Denied');
        setSnackbarOpen(true);
      } else {
        // Handle other errors if needed
        setErrorMessage('An error occurred while deleting the account group. Please try again later.');
        setSnackbarOpen(true);
        // Alternatively, you can log the detailed error to the console for debugging
        console.error('Error:', error);
      }
    }
  };

  const handleCloseSnackbar = () => {
    // Close the Snackbar
    setSnackbarOpen(false);
    // Reset the error message
    setErrorMessage('');
  }; 

  const setEditForm = (designation) => {
    setFormMode('edit');
    setDesigCode(designation.DesigCode);
    setDesignation(designation.Designation);
    setDesignationEng(designation.DesignationEng);
    setShowGrid(false);
  };

  const handleSearch = (searchQuery) => {
    const filtered = designations.filter((designation) => {
      const DesigCode = designation.DesigCode.toString().toLowerCase();
      const Designation = designation.Designation.toString().toLowerCase();
      const DesignationEng = designation.DesignationEng.toString().toLowerCase();

      return (
        DesigCode.includes(searchQuery.toLowerCase()) ||
        Designation.includes(searchQuery.toLowerCase()) ||
        DesignationEng.includes(searchQuery.toLowerCase())
      );
    });

    setDesignationMasterEntries(filtered);
  };

  useEffect(() => {
    handleSearch(props.searchQuery);
  }, [props.searchQuery, designations]);

  const handleshowandhide = () => {
    setShowGrid(!showGrid);
    setDesignations(designations);
  };

  const handleCancel = () => {
    setFormMode('add');
    setEditDesigCode('');
    setDesigCode('');
    setDesignation('');
    setDesignationEng('');
  };

  const componentPDF = useRef();

  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "DesignationData",
    onAfterPrint: () => alert("Pdf downloaded"),
    pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }
        
        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
  });

  return (
    <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>DesignationMaster</h1>
      <Grid item>
        <Button
          variant="contained"
          className="view-button"
          onClick={handleshowandhide}
          sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
        >
          {showGrid ? 'Add' : 'Back'}
        </Button>
      </Grid>
      {showGrid && <Grid item>
        <Button
          variant="contained"
          onClick={generatePDF}
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Download PDF
        </Button>
      </Grid>}
      {showGrid && <Grid item>
        <Button
          variant="contained"
          sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
        >
          Export
        </Button>
      </Grid>}
      {!showGrid && (
        <>
        <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>{formMode === 'add' ? 'Add' : 'Edit'}</h2>
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="desigCode" style={{ width: '150px', marginRight: '10px' }}>DesigCode</label>
            <input
              type="text"
              value={desigCode}
              readOnly
              placeholder="DesigCode"
              style={{ marginBottom: '5px', padding: '5px', width: '10%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="designation" style={{ width: '150px', marginRight: '10px' }}>Designation</label>
            <input
              type="text"
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
              placeholder="Designation"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
          <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
            <label htmlFor="designationEng" style={{ width: '150px', marginRight: '10px' }}>DesignationEng</label>
            <input
              type="text"
              value={designationEng}
              onChange={(e) => setDesignationEng(e.target.value)}
              placeholder="DesignationEng"
              style={{ marginBottom: '5px', padding: '5px', width: '40%' }}
            />
          </div>
        </div>
        <div>
          <button
            className={formMode === 'add' ? 'add-button' : 'update-button'}
            onClick={formMode === 'add' ? addDesignation : () => updateDesignation(desigCode)}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginBottom: '10px',
            }}
          >
            {formMode === 'add' ? 'Add' : 'Update'}
          </button>
          <button
            className="view-button"
            onClick={handleCancel}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#f44336',
              color: 'white',
              border: 'none',
              cursor: 'pointer',
              marginLeft: '10px',
              marginBottom: '10px',
            }}
          >
            Cancel
          </button>
        </div>
      </>      
      )}
      {showGrid && (
        <div ref={componentPDF} style={{ width: '100%' }}>
          <h2>Entries</h2>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              border: '1px solid #ccc',
            }}
          >
            <thead>
              <tr style={{ background: '#f2f2f2', color: 'black' }}>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  DesigCode
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  Designation
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                >
                  DesignationEng
                </th>
                <th
                  style={{
                    padding: '8px',
                    background: '#f2f2f2',
                    border: '1px solid #ccc',
                  }}
                  className="print-hide"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {designationMasterEntries.map((designation) => (
                <tr key={designation.DesigCode} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{designation.DesigCode}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{designation.Designation}</td>
                  <td style={{ padding: '8px', border: '1px solid #ccc' }}>{designation.DesignationEng}</td>
                  <td className="print-hide">
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(76, 175, 80)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                        marginRight: '5px',
                        marginLeft: '10px',
                      }}
                      onClick={() => setEditForm(designation)}
                    >
                      Edit
                    </button>
                    <button
                      style={{
                        padding: '5px 10px',
                        backgroundColor: 'rgb(244, 67, 54)',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        setDeleteEntryNo({DesignCode: designation.DesigCode});
                        setOpenConfirmation(true); 
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Snackbar for displaying error messages */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'center', horizontal: 'center'}} // Center the Snackbar
      >
        <MuiAlert elevation={6} variant="filled" severity="error" sx={{fontSize:'16px'}} onClose={handleCloseSnackbar}>
          {errorMessage}
        </MuiAlert>
      </Snackbar>

      <Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                DELETE
              </Button>
            </DialogActions>
          </Dialog>
    </div>
  );
}

export default DesignationMaster;
